import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

type UseDeclareVictoryLinkReturn = ModelHookResult<
	{
		declareVictoryLink: string;
	},
	{ onDeclareVictoryClick: () => void }
>;

export function useDeclareVictoryLink(): UseDeclareVictoryLinkReturn {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();

	const track = useTracking();
	const handleDeclareVictoryClick = useCallback(() => {
		void track('petition_manage_declare_victory_click', {
			signature_count: petition.signatureState.signatureCount.displayed,
		});
	}, [petition.signatureState.signatureCount.displayed, track]);

	return {
		data: {
			declareVictoryLink: `/p/${encodeURIComponent(petition.slug)}/victory`,
		},
		actions: {
			onDeclareVictoryClick: handleDeclareVictoryClick,
		},
	};
}
